import styled from "styled-components";

export const CardsContentContainer = styled.div`
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding: 8px 48px;
  align-items: center;
  gap: 16px;
  flex: 1;
`;

export const CardsGridContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 32px;
  width: 100%;
`;

export const CardsGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(
    ${({ numberOfColumns }) => numberOfColumns},
    minmax(0, 1fr)
  );
  grid-auto-rows: 1fr;
  gap: 20px;
  width: 100%;
  word-break: break-word;
  overflow-wrap: break-word;
`;

export const CardsPreviewContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  padding: 2px;
`;
